import * as React from "react";
import { Trans } from "react-i18next";

export const BalanceUpdateHintDetails = () => {
  return (
    <Trans i18nKey="transaction.BalanceUpdateHintDetails_details">
      Hint
    </Trans>
  );
};
